module.exports = __webpack_public_path__ + "static/ergotec-logo-132f4e6d787f39fad71a58bdee8ddb40.png";